import { render, staticRenderFns } from "./Template51.vue?vue&type=template&id=68a2c8f4&scoped=true&"
import script from "./Template51.vue?vue&type=script&lang=js&"
export * from "./Template51.vue?vue&type=script&lang=js&"
import style0 from "./Template51.vue?vue&type=style&index=0&id=68a2c8f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a2c8f4",
  null
  
)

export default component.exports